import { Injectable, Type, Component } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { StorageService } from 'app/core/services/storage.service';
import { VimeoModalComponent } from 'app/shared/components/vimeo-modal/vimeo-modal.component';
import { ModalResult, SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';

@Injectable()
export class VimeoModalService {

    private readonly ModalsHistoryKey = 'openedModals'; 

    constructor(
        private modalService: SmartModalService,
        private storageService: StorageService) { }

    open(info: VimeoModalInfo, userOpened?: boolean): Observable<ModalResult> {
        
        let history = this.storageService.get(this.ModalsHistoryKey);
        history = history || {};

        let isFirstVisit = !history[info.category];
        if (isFirstVisit) {
            history[info.category] = [];
        }

        if (!history[info.category].some(i => i == info.key)) {
            history[info.category].push(info.key);
            this.storageService.set(this.ModalsHistoryKey, history);
        }

        // For backwards compatibility
        let previouslyOpened = this.storageService.keys().some(k => k.startsWith(info.category)); 
        // 
        if (userOpened || (isFirstVisit && !previouslyOpened)) {            
            let data = { id: info.videoId, key: info.key, category: info.category, userOpened: userOpened };
            return this.modalService.open(VimeoModalComponent, data, info.title, ModalSize.Lg);
        }

        return Observable.of(new ModalResult({ didNotOpen: true }));
    }
}

export class VimeoModalInfo {

    constructor(
        public videoId: string,
        public key: string,
        public category: string,
        public title: string) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/vimeo-modal/vimeo-modal.service.ts